import React from 'react';
import { Box } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import { CircleIcon, Typography } from '../../../../ui-kit';

interface RealValutionProps {
    variant: 'success' | 'error';
}

const RealValuationCell: React.FC<RealValutionProps> = ({ variant, children }) => (
    <Typography variant='body2' colorVariant={variant}>
        <Box display='flex' justifyContent='center'>
            {children}
            <Box ml={1} />
            <CircleIcon
                isSmall
                color={variant}
                iconComponent={variant === 'success'
                ? <ArrowUpwardIcon fontSize='inherit' />
                : <ArrowDownwardIcon fontSize='inherit' />}
            />
        </Box>
    </Typography>
);

export default RealValuationCell;
